import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Dropdown } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { pages } = this.props

    return (
      <div className={styles.breadcrumbs}>
        <Container>
          <div className='d-none d-md-flex align-items-center'>
            <a className={styles.breadcrumbs_main} href="/">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 7.20037V11.4545C1 12.3456 1 12.7914 1.17711 13.1317C1.33291 13.4311 1.58132 13.6742 1.88708 13.8268C2.23435 14 2.68918 14 3.59749 14H11.4025C12.3108 14 12.765 14 13.1123 13.8268C13.418 13.6742 13.6673 13.4311 13.8231 13.1317C14 12.7917 14 12.3466 14 11.4573V7.20037C14 6.77531 13.9996 6.56267 13.9468 6.36488C13.9001 6.1896 13.8233 6.02373 13.7193 5.87384C13.6021 5.7047 13.439 5.56444 13.1123 5.28454L9.21228 1.94353C8.60566 1.42385 8.30235 1.16415 7.961 1.06531C7.66022 0.978229 7.33962 0.978229 7.03884 1.06531C6.69775 1.16407 6.39488 1.42353 5.78917 1.94242L1.88788 5.28454C1.56115 5.56444 1.39816 5.7047 1.28088 5.87384C1.17696 6.02373 1.09957 6.1896 1.05279 6.36488C1 6.56267 1 6.77531 1 7.20037Z" stroke="black" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            {pages.map((elm, k) => {
              if(elm.current) return (
                <div key={k}>
                  / <div className={styles.breadcrumbs_current}>{elm.name}</div>
                </div>
              )
              return (
                <div key={k}>
                  / <a href={elm.url} className={styles.breadcrumbs_current}>{elm.name}</a>
                </div>
              )
            })}
          </div>
          <div className='d-flex d-md-none align-items-center'>
            <a className={styles.breadcrumbs_main} href="/">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 7.20037V11.4545C1 12.3456 1 12.7914 1.17711 13.1317C1.33291 13.4311 1.58132 13.6742 1.88708 13.8268C2.23435 14 2.68918 14 3.59749 14H11.4025C12.3108 14 12.765 14 13.1123 13.8268C13.418 13.6742 13.6673 13.4311 13.8231 13.1317C14 12.7917 14 12.3466 14 11.4573V7.20037C14 6.77531 13.9996 6.56267 13.9468 6.36488C13.9001 6.1896 13.8233 6.02373 13.7193 5.87384C13.6021 5.7047 13.439 5.56444 13.1123 5.28454L9.21228 1.94353C8.60566 1.42385 8.30235 1.16415 7.961 1.06531C7.66022 0.978229 7.33962 0.978229 7.03884 1.06531C6.69775 1.16407 6.39488 1.42353 5.78917 1.94242L1.88788 5.28454C1.56115 5.56444 1.39816 5.7047 1.28088 5.87384C1.17696 6.02373 1.09957 6.1896 1.05279 6.36488C1 6.56267 1 6.77531 1 7.20037Z" stroke="black" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            {pages.length > 1 &&
              <Dropdown as="div" className='breadcrumb-item'>
                / <Dropdown.Toggle as="div" className={styles.breadcrumbs_current}> ... </Dropdown.Toggle>
                <Dropdown.Menu>
                  {pages.map((elm, k) => {
                    if(!elm.current) return (
                      <Dropdown.Item key={k} href={elm.url}>{elm.name}</Dropdown.Item>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            }
            {pages.map((elm, k) => {
              if(elm.current) return (
                <div key={k}>
                  / <div className={styles.breadcrumbs_current}>{elm.name}</div>
                </div>
              )
            })}
          </div>
        </Container>
      </div>
    )
  }
}

Main.propTypes = {
  pages: PropTypes.object
}